// @ts-nocheck

import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import Link from '../../../../components/Link';
import { __ } from '../../../../i18n/l10n';
import { showWebsiteLoginForm } from '../../../../utils';
import Primary from '../buttons/Primary';

const Wrap = styled.div`
  flex: 0 0 auto;
`;

const BetButton = styled(Primary)`
  && {
    box-sizing: border-box;
    width: 100%;
    ${({ $isBlack, theme }) =>
      $isBlack
        ? css`
            background-color: ${theme.grids.colors.darkgrey4};
          `
        : undefined};
  }
`;

type GridsBasketButtonProps = {
  className?: string;
  setBasketPending: () => void;
  submitBasket: () => void;
  clearBasket: () => void;
  isDisabled: boolean;
  isConnected: boolean;
  isValidated: boolean;
};

const GridsBasketButton = ({
  submitBasket,
  clearBasket,
  isDisabled,
  isConnected,
  isValidated = false,
  className,
}: GridsBasketButtonProps) => {
  const history = useHistory();
  const location = useLocation();

  const handleSubmit = useCallback(() => {
    submitBasket();
  }, [submitBasket]);

  const handleShowLoginForm = () => {
    showWebsiteLoginForm();
  };

  const handleOkButton = useCallback(() => {
    clearBasket();
    if (location.hash) {
      // $FlowFixMe
      history.goBackOrReplace?.(location.pathname);
    }
  }, [clearBasket, history, location.hash, location.pathname]);

  return (
    <Wrap className={className}>
      {!isConnected && Target.__MOBILE__ ? (
        <Link
          to={{
            hash: '#login',
            state: { modal: true },
          }}
        >
          <BetButton isDisabled={isDisabled}>{__('Sign-in and place bet')}</BetButton>
        </Link>
      ) : null}
      {!isConnected && !Target.__MOBILE__ ? (
        <BetButton onClick={handleShowLoginForm} isDisabled={isDisabled}>
          {__('Sign-in and place bet')}
        </BetButton>
      ) : null}
      {isConnected && !isValidated ? (
        <BetButton isDisabled={isDisabled} onClick={handleSubmit}>
          {__('!action:Bet')}
        </BetButton>
      ) : null}
      {isConnected && isValidated ? (
        <BetButton $isBlack onClick={handleOkButton}>
          {__('ok')}
        </BetButton>
      ) : null}
    </Wrap>
  );
};

export default GridsBasketButton;
